import { Container } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ContainerStyled = styled(Container)<any>(() => ({
	position: 'relative',
	'&.MuiContainer-maxWidthLg': {
		maxWidth: 1320
	},
	'&.MuiContainer-root': {
		paddingLeft: '24px',
		paddingRight: '24px'
	},
	// Prevent swiper's flickering on initial load...
	'.swiper-slide': {
		width: 0
	},
	// Prevent layout shift
	".carousel-wrap": {
		minHeight: "210px"
	}
}));